<template>
    <div class="image-generator">
        <!-- 生成器主界面：应用毛玻璃效果和更现代的圆角 -->
        <div class="generator-interface max-md:!p-0">
            <!-- 顶部导航栏：桌面端 Tab 和模型选择器并排，移动端垂直排列 -->
            <div
                class="flex w-full max-md:flex-col justify-between items-center"
            >
                <!-- 导航标签页：胶囊样式设计 (参考 NewVideoGenerator) -->
                <div class="generator-tabs max-md:w-full max-md:justify-center">
                    <div
                        v-for="(tab, index) in tabs"
                        :key="index"
                        class="tab-item max-md:flex-1"
                        :class="{ active: activeTab === tab?.value }"
                        @click="setActiveTab(tab)"
                    >
                        <span :class="tab?.icon" class="w-4 h-4"></span>
                        <!-- 图标逻辑 -->
                        <!-- <div class="tab-icon">
                            <svg
                                v-if="index === 0"
                                class="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <img
                                v-else
                                src="~/assets/images/videoImgPages/imgToConverse.png"
                                class="w-4 h-4"
                            />
                        </div> -->
                        {{ tab?.name }}
                    </div>
                </div>

                <!-- 模型选择器：使用 NewModelSelect 并应用自定义模糊样式 -->
                <div
                    class="model-selector-wrapper md:max-w-[400px] max-md:w-full max-md:mt-5"
                >
                    <tool-new-model-select
                        v-model:model="selectedModelKey"
                        :model_list="currentModelList"
                        :type="currentModelType"
                        :style_class="model_select_style"
                        :hideLabel="true"
                        popper_style="popper_style"
                    ></tool-new-model-select>
                </div>
            </div>

            <!-- 内容区域 -->
            <div class="mt-5">
                <!-- 文生图 Tab -->
                <div v-if="activeTab === 'text'" class="tab-panel">
                    <div
                        class="input-section input-box flex justify-center relative"
                    >
                        <!-- 提示词输入区域 -->
                        <textarea
                            v-model="promptText"
                            class="prompt-textarea !resize-none"
                            :placeholder="t('menus.promptPlaceholder')"
                            rows="4"
                            maxlength="2000"
                        ></textarea>

                        <!-- 生成按钮：直接嵌入在输入框内部右下角 -->
                        <div class="generate-trigger absolute bottom-5">
                            <button
                                v-if="isLoggedIn"
                                class="generate-button shadow-[0_0_20px_rgba(153,247,104,0.4)] animate-cta-pulse transition-all duration-300"
                                :class="{ disabled: !canGenerate }"
                                :disabled="!canGenerate"
                                @click="generateImage($event)"
                            >
                                <div class="btn-icon">
                                    <img
                                        src="~/assets/images/common/create_btn.svg"
                                        alt="Create icon"
                                        aria-hidden="true"
                                        role="presentation"
                                        class="w-6 h-6"
                                    />
                                </div>
                                <span class="btn-text">{{
                                    t('menus.create')
                                }}</span>
                            </button>

                            <!-- 未登录时的引导按钮 -->
                            <div
                                v-else-if="LOGIN_ENTRY_ENABLED"
                                class="try-now-btn font-medium hover:bg-[#82d945] hover:scale-105 shadow-[0_0_20px_rgba(153,247,104,0.4)] animate-cta-pulse transition-all duration-300"
                                @click="handleTryNow"
                            >
                                <img
                                    src="https://static.weryai.com/growth/image/weryai_ce29b49010526e7fa8e91d971a726de4.webp"
                                    class="w-5 h-5"
                                    alt="Gift icon"
                                    aria-hidden="true"
                                    role="presentation"
                                />
                                <span>{{ t('common.loginToGetFree') }}</span>
                            </div>
                        </div>

                        <!-- 字符计数显示 -->
                        <!-- <div class="char-count-overlay">
                            {{ promptText.length }} / 2000
                        </div> -->
                    </div>
                </div>

                <!-- 图生图 Tab (已修正按钮位置和跳转逻辑) -->
                <div v-if="activeTab === 'image'" class="tab-panel">
                    <div class="input-section relative flex justify-center">
                        <!-- 图片上传组件 (更新为新版 NewModelPageImageUpload) -->
                        <NewModelPageImageUpload
                            :max-size-m-b="10"
                            :max-resolution="4096"
                            :allow-multiple="false"
                            accept-types="image/jpeg,image/png,image/webp"
                            @upload-success="onImageUploadSuccess"
                            @upload-error="onImageUploadError"
                            @files-change="onImageFilesChange"
                        />

                        <!-- 生成按钮：绝对定位在上传区域内部右下角 -->
                        <div class="generate-trigger absolute bottom-5">
                            <button
                                v-if="isLoggedIn"
                                class="generate-button shadow-[0_0_20px_rgba(153,247,104,0.4)] animate-cta-pulse transition-all duration-300"
                                :class="{
                                    disabled: !canGenerate,
                                    loading: isGenerating,
                                }"
                                :disabled="!canGenerate || isGenerating"
                                @click.stop="handleImageGenerate($event)"
                            >
                                <div class="btn-icon">
                                    <img
                                        src="~/assets/images/common/create_btn.svg"
                                        alt="Create icon"
                                        aria-hidden="true"
                                        role="presentation"
                                        class="w-6 h-6"
                                    />
                                </div>
                                <span class="btn-text">
                                    {{
                                        isGenerating
                                            ? t('menus.creating')
                                            : t('menus.create')
                                    }}
                                </span>
                            </button>

                            <!-- 未登录时的引导按钮 -->
                            <div
                                v-else-if="LOGIN_ENTRY_ENABLED"
                                class="try-now-btn font-medium hover:bg-[#82d945] hover:scale-105 shadow-[0_0_20px_rgba(153,247,104,0.4)] animate-cta-pulse transition-all duration-300"
                                @click="handleTryNow"
                            >
                                <img
                                    src="https://static.weryai.com/growth/image/weryai_ce29b49010526e7fa8e91d971a726de4.webp"
                                    class="w-5 h-5"
                                    alt="Gift icon"
                                    aria-hidden="true"
                                    role="presentation"
                                />
                                <span>{{ t('common.loginToGetFree') }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 提示文字移出 relative 容器，确保按钮定位不受干扰 -->
                    <p class="upload-hint text-center !mt-[10px]">
                        {{ t('upload.supportedImageFormats') }} (Max 10MB)
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue'
import NewModelPageImageUpload from '~/components/NewModelPageImageUpload.vue'
import ToolNewModelSelect from '~/components/Tool/NewModelSelect.vue'
import { analyticsEvent } from '~/utils/log-event-func'
import { useI18n } from '~/composables/useI18n'
import { LOGIN_ENTRY_ENABLED } from '~/utils/feature-flags'
import { useToolsHooks } from '@/utils/useHooks'
import { useAppStore } from '~/stores/app'
import { formatAndGroupData } from '~/utils/common'
import { showLoginModal } from '~/utils/emitter'
import { useUserStore } from '~/stores/user'

/**
 * NewImageGenerator 组件说明：
 * 1. 样式重构：采用了毛玻璃 (Glassmorphism) 风格，使用半透明背景和高斯模糊。
 * 2. 布局优化：针对桌面端将 Tab 栏和模型选择器并列显示，移动端则垂直堆叠。
 * 3. 交互改进：更新图生图 UI 为新版，增加了生成按钮并与 Sora 2 保持一致。
 */

const userStore = useUserStore()
const isLoggedIn = computed(() => userStore.isLoggedIn)
const { t } = useI18n()
const { handleMenuLinkClick, imageModelsEnums } = useToolsHooks()
const appStore = useAppStore()
const modelData = computed(() => appStore.modelData)

// 根据 modelKey 匹配当前模型的元数据配置
const currentModelConfig = computed(() => {
    const key = selectedModelKey.value || props.modelKey
    return imageModelsEnums.value.find(m => m.model_key === key)
})

// 定义组件 Props
interface Props {
    modelName?: string
    defaultTab?: string
    modelKey?: string
}

const props = withDefaults(defineProps<Props>(), {
    modelName: 'Google Nano Banana',
    defaultTab: 'image',
    modelKey: 'GEMINI_2_5_FLASH',
})

// 模型名称与后端 key 的映射表
const MODEL_NAME_MAPPING: Record<string, string> = {
    'Google Nano Banana': 'Nano-banana',
    FLUX: 'Flux',
    'Wan 2.5': 'Wan2.5',
    'Seedream 4.0': 'Seedream 4.0',
}

// 响应式状态
const activeTab = ref(props.defaultTab)
const promptText = ref('')
const uploadedImage = ref<File | null>(null)
const selectedModelKey = ref('')
const isGenerating = ref(false)

// 计算当前模型支持的业务类型
const currentModelType = computed(() => {
    return activeTab.value === 'text' ? 'text_to_image' : 'image_to_image'
})

// 根据业务类型获取模型列表并分组
const currentModelList = computed(() => {
    if (!modelData.value) return []

    const imageModels =
        modelData.value?.image_models?.[currentModelType.value] || []
    const finalData = formatAndGroupData(imageModels)

    return finalData
})

// 动态处理 Tabs
const tabs = computed(() => {
    const allTabs = [
        {
            name: t('menus.createModal.imageToImage'),
            icon: 'i-edit-pic-icon',
            value: 'image',
            type: 'image-to-image',
        },
        {
            name: t('menus.createModal.textToImage'),
            icon: 'i-pen-icon',
            value: 'text',
            type: 'text-to-image',
        },
    ]

    // 如果在 useHooks 中找到了该模型且定义了支持类型，则进行过滤
    const config = currentModelConfig.value
    if (config?.supportType) {
        return allTabs.filter(tab =>
            config.supportType.includes(tab.type)
        )
    }

    return allTabs
})

// 自动纠正 activeTab，确保当前选择的 Tab 在支持范围内
watch(
    () => tabs.value,
    newTabs => {
        if (newTabs.length > 0) {
            const supportedValues = newTabs.map(t => t.value)
            // 如果当前 activeTab 不在支持列表中
            if (!supportedValues.includes(activeTab.value)) {
                // 自动选择第一个支持的 Tab
                activeTab.value = supportedValues[0] as 'text' | 'image'
            }
        }
    },
    { immediate: true }
)

// 按钮可用状态逻辑
const canGenerate = computed(() => {
    if (activeTab.value === 'text') return promptText.value.trim().length > 0
    return uploadedImage.value !== null
})

// 切换 Tab
const setActiveTab = (tab: any) => {
    activeTab.value = tab.value as 'text' | 'image'
}

// 自动匹配并选择默认模型
watch(
    [() => currentModelList.value, () => activeTab.value],
    ([newModelList]) => {
        if (newModelList?.length > 0) {
            const actualName =
                MODEL_NAME_MAPPING[props.modelName || ''] || props.modelName
            const matched = newModelList.find(
                (m: any) =>
                    m.model_key === props.modelKey ||
                    (m.title &&
                        m.title
                            .toLowerCase()
                            .includes(actualName?.toLowerCase()))
            )

            if (
                !selectedModelKey.value ||
                !newModelList.some(m => m.model_key === selectedModelKey.value)
            ) {
                selectedModelKey.value =
                    matched?.model_key || newModelList[0]?.model_key || ''
            }
        }
    },
    { immediate: true }
)

// 处理文生图生成：存储 Prompt 并跳转
const generateImage = (event: MouseEvent) => {
    if (!canGenerate.value) return
    const prompt = promptText.value.trim()
    if (prompt && import.meta.client) {
        localStorage.setItem('modelPagePrompt', prompt)
        localStorage.setItem('modelPageModelKey', selectedModelKey.value)

        analyticsEvent('click_model_page_common_create', {
            model_name: selectedModelKey.value,
            type: 'image',
        })

        const encodedPrompt = encodeURIComponent(prompt)
        const path = `/text-to-image?defaultModel=${props.modelKey}&customType=modelPage&prompt=${encodedPrompt}&selectedModel=${selectedModelKey.value}`
        handleMenuLinkClick(path, event)
    }
}

// 处理图生图点击逻辑 (作为自动跳转的兜底)
const handleImageGenerate = (event: MouseEvent) => {}

// 修正：增强 URL 获取逻辑，确保自动跳转生效
const onImageUploadSuccess = (files: any[]) => {
    if (files.length > 0 && import.meta.client) {
        const uploadResult = files[0].uploadResult
        const imageUrl =
            uploadResult?.data?.object_url_list?.[0] ||
            uploadResult?.data?.url ||
            uploadResult?.url ||
            files[0].url

        if (imageUrl) {
            isGenerating.value = true
            localStorage.setItem('modelPageFileUrl', imageUrl)
            localStorage.setItem('modelPageModelKey', selectedModelKey.value)

            analyticsEvent('click_model_page_common_create', {
                model_name: selectedModelKey.value,
                type: 'image',
            })

            const encodedImageUrl = encodeURIComponent(imageUrl)
            handleMenuLinkClick(
                `/image-to-image?defaultModel=${props.modelKey}&customType=modelPage&imageUrl=${encodedImageUrl}`
            )
        }
    }
}

const onImageUploadError = (err: string) => {
    console.error('Upload Error:', err)
    isGenerating.value = false
}
const onImageFilesChange = (files: any[]) => {
    uploadedImage.value = files.length > 0 ? files[0].file : null
}

const handleTryNow = () => showLoginModal()

onMounted(() => {
    if (!modelData.value) appStore.getModelList()
})

// 模型选择器自定义内联样式
const model_select_style = `border-radius: 9999px; border: 1px solid rgba(255, 255, 255, 0.10); background: rgba(0, 0, 0, 0.20); backdrop-filter: blur(6px);`
</script>

<style lang="less" scoped>
.image-generator {
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
}

.generator-interface {
    padding: 2rem;
    border-radius: 1.5rem;
}

/* 导航栏样式：胶囊形状与毛玻璃效果 */
.generator-tabs {
    display: inline-flex;
    border-radius: 9999px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(12px);
    gap: 5px;
    padding: 4px;
}

.tab-item {
    padding: 0.75rem 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border-radius: 9999px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    border: 1px solid transparent;

    &:hover {
        color: #99f768;
    }

    &.active {
        color: #99f768;
        border-color: rgba(153, 247, 104, 0.3);
        background: rgba(255, 255, 255, 0.05);
        box-shadow: 0 0 15px 0 rgba(153, 247, 104, 0.1);
    }
}

/* 输入框区域：深色半透明背景 */
.input-box {
    width: 100%;
    min-height: 220px;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(25px);
    padding: 24px;
}

.prompt-textarea {
    width: 100%;
    color: white;
    font-size: 14px;
    background: transparent;
    border: none;
    outline: none;
    &::placeholder {
        color: rgba(255, 255, 255, 0.6);
    }
    &:focus {
        --tw-ring-color: transparent;
    }
}

/* 生成按钮样式：完全同步自 Sora 2 页面 */
.generate-button {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 2.5rem;
    background: #99f768;
    color: #000;
    border-radius: 0.75rem;
    font-weight: 600;
    transition: all 0.3s ease;

    &:hover:not(.disabled) {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(153, 247, 104, 0.4);
    }

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &.loading {
        cursor: wait;
        opacity: 1;
        color: #fff;
    }
}

.btn-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
}

.btn-text {
    font-weight: 600;
}

/* 引导登录按钮 */
.try-now-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: #99f768;
    color: #000;
    border-radius: 10px;
    cursor: pointer;
    font-size: 14px;
}

.char-count-overlay {
    position: absolute;
    bottom: 24px;
    left: 24px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.3);
}

.upload-hint {
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 10px;
}

/* 入场动画 */
.tab-panel {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>

<style>
/* 下拉菜单全局样式适配 */
.popper_style {
    background: rgba(0, 0, 0, 0.5) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}
</style>
